'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _simpleReactForm = require('simple-react-form');

var _Button = require('../../Button');

var _Button2 = _interopRequireDefault(_Button);

var _reactSortableHoc = require('react-sortable-hoc');

var _cancel = require('react-icons/lib/md/cancel');

var _cancel2 = _interopRequireDefault(_cancel);

var _without = require('lodash/without');

var _without2 = _interopRequireDefault(_without);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Sortable Elements
var SortableItem = (0, _reactSortableHoc.SortableElement)(function (_ref) {
  var item = _ref.item;
  return _react2.default.createElement(
    'div',
    null,
    item
  );
});

var SortableList = (0, _reactSortableHoc.SortableContainer)(function (_ref2) {
  var items = _ref2.items,
      draggable = _ref2.draggable;

  return _react2.default.createElement(
    'div',
    null,
    items.map(function (item, index) {
      return _react2.default.createElement(SortableItem, { disabled: !draggable, key: 'item-' + index, index: index, item: item });
    })
  );
});

var Array = (_temp = _class = function (_ArrayComponent) {
  (0, _inherits3.default)(Array, _ArrayComponent);

  function Array() {
    (0, _classCallCheck3.default)(this, Array);
    return (0, _possibleConstructorReturn3.default)(this, (Array.__proto__ || Object.getPrototypeOf(Array)).apply(this, arguments));
  }

  (0, _createClass3.default)(Array, [{
    key: 'removeItem',
    value: function removeItem(index) {
      var value = this.props.value || [];
      var newArray = (0, _without2.default)(value, value[index]);
      this.props.onChange(newArray);
    }
  }, {
    key: 'renderRemoveButton',
    value: function renderRemoveButton(index) {
      var _this2 = this;

      if (this.props.disabled) return;
      return _react2.default.createElement(_Button2.default, { danger: true, label: this.props.removeLabel, onClick: function onClick() {
          return _this2.removeItem(index);
        } });
    }
  }, {
    key: 'renderAddButton',
    value: function renderAddButton() {
      var _this3 = this;

      if (!this.props.showAddButton) return;
      if (this.props.disabled) return;
      return _react2.default.createElement(_Button2.default, { primary: true, label: this.props.addLabel, onClick: function onClick() {
          return _this3.addItem();
        } });
    }
    // this function return the specific field

  }, {
    key: 'renderChildrenItem',
    value: function renderChildrenItem(_ref3) {
      var _this4 = this;

      var index = _ref3.index,
          children = _ref3.children;

      return _react2.default.createElement(
        'div',
        { className: this.props.childrenClassName, key: this.props.fieldName + '.' + index },
        _react2.default.createElement(
          'div',
          { className: 'os-array-item-content' },
          this.renderChildrenItemWithContext({ index: index, children: children })
        ),
        _react2.default.createElement(
          'div',
          { className: 'os-array-item-remove' },
          _react2.default.createElement(
            _Button2.default,
            { danger: true, onClick: function onClick() {
                return _this4.removeItem(index);
              } },
            _react2.default.createElement(_cancel2.default, null)
          )
        )
      );
    }

    // Render children according to elements inside value

  }, {
    key: 'renderChildren',
    value: function renderChildren() {
      var _this5 = this;

      var value = this.props.value || [];
      if (this.props.autoAddItem && !this.props.disabled && value.length === 0) {
        value.push({});
      }
      var items = value.map(function (item, index) {
        var children = _this5.getChildrenComponents(item, index);
        return _this5.renderChildrenItem({ index: index, children: children });
      });
      var onSortEnd = function onSortEnd(_ref4) {
        var oldIndex = _ref4.oldIndex,
            newIndex = _ref4.newIndex;
        return _this5.props.onChange((0, _reactSortableHoc.arrayMove)(value, oldIndex, newIndex));
      };
      return _react2.default.createElement(SortableList, {
        helperClass: 'os-s-array-grabbing',
        distance: 2,
        items: items,
        draggable: this.props.draggable,
        onSortEnd: onSortEnd });
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'div',
        { style: { marginTop: 20 } },
        _react2.default.createElement(
          'div',
          null,
          this.props.label
        ),
        _react2.default.createElement(
          'div',
          { style: { color: 'red' } },
          this.props.errorMessage
        ),
        _react2.default.createElement(
          'div',
          { className: this.props.parentClassName },
          this.renderChildren()
        ),
        _react2.default.createElement(
          'div',
          { style: { marginTop: 10, marginBottom: 10 } },
          this.renderAddButton()
        )
      );
    }
  }]);
  return Array;
}(_simpleReactForm.ArrayComponent), _class.propTypes = (0, _extends3.default)({}, _simpleReactForm.ArrayComponent.propTypes, {
  childrenClassName: _propTypes2.default.string,
  draggable: _propTypes2.default.bool
}), _class.defaultProps = (0, _extends3.default)({}, _simpleReactForm.ArrayComponent.defaultProps, {
  childrenClassName: 'os-s-array os-s-array-1',
  draggable: true
}), _temp);
exports.default = Array;


//////////////////
// WEBPACK FOOTER
// ./node_modules/orionsoft-parts/lib/components/fields/ArrayComponent/index.js
// module id = 3294
// module chunks = 0